import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from "react";
import PropTypes from "prop-types";
import { parse, format, getMonth, getDate, getYear, getDay, getHours, getMinutes, addMinutes, isValid, addDays, startOfDay, isSameDay } from "date-fns";
import O2TooltipPopoverWrapper from "./o2-tooltip-popover-wrapper";
import values from "./o2-date-picker-texts";

var O2DatePickerEx = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(O2DatePickerEx, _React$PureComponent);

  function O2DatePickerEx(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "pickDate", function (date) {
      var _this$state = _this.state,
          year = _this$state.year,
          month = _this$state.month,
          selectedHour = _this$state.selectedHour,
          selectedMinute = _this$state.selectedMinute;

      if (date.current) {
        _this.props.onChange(format(new Date(year, month, date.day, selectedHour ? selectedHour : 0, selectedMinute ? selectedMinute : 0), _this.props.dateFormat));

        _this.props.toggle();
      } else {
        if (date.day < 15) {
          _this.nextMonth();
        } else {
          _this.previousMonth();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "pickTime", function (time) {
      var _this$state2 = _this.state,
          selectedYear = _this$state2.selectedYear,
          selectedMonth = _this$state2.selectedMonth,
          selectedDay = _this$state2.selectedDay;
      var today = new Date();

      _this.props.onChange(format(new Date(selectedYear ? selectedYear : getYear(today), selectedMonth ? selectedMonth : getMonth(today), selectedDay ? selectedDay : getDate(today), time.hour, time.minute), _this.props.dateFormat));

      _this.props.toggle();
    });

    _defineProperty(_assertThisInitialized(_this), "nextMonth", function () {
      if (_this.state.month === 11) {
        _this.updateState(_this.state.year + 1, 0);
      } else {
        _this.updateState(_this.state.year, _this.state.month + 1);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "previousMonth", function () {
      if (_this.state.month === 0) {
        _this.updateState(_this.state.year - 1, 11);
      } else {
        _this.updateState(_this.state.year, _this.state.month - 1);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "goToToday", function () {
      var today = new Date();

      _this.updateState(getYear(today), getMonth(today));
    });

    _defineProperty(_assertThisInitialized(_this), "timeUpHandler", function () {
      _this.timePickerRef.current.scrollTop = _this.timePickerRef.current.scrollTop - _this.timePickerFirstElementRef.current.clientHeight;
    });

    _defineProperty(_assertThisInitialized(_this), "timeDownHandler", function () {
      _this.timePickerRef.current.scrollTop = _this.timePickerRef.current.scrollTop + _this.timePickerFirstElementRef.current.clientHeight;
    });

    _defineProperty(_assertThisInitialized(_this), "toggleMonthPicker", function () {
      _this.setState({
        monthPickerOpen: !_this.state.monthPickerOpen,
        yearPickerOpen: false
      });

      _this.monthPickerRef.current.scrollTop = _this.monthPickerSelectedRef.current.offsetTop - 50;
    });

    _defineProperty(_assertThisInitialized(_this), "toggleYearPicker", function () {
      _this.setState({
        yearPickerOpen: !_this.state.yearPickerOpen,
        monthPickerOpen: false
      });

      _this.yearPickerRef.current.scrollTop = _this.yearPickerSelectedRef.current.offsetTop - 50;
    });

    _defineProperty(_assertThisInitialized(_this), "selectMonth", function (index) {
      _this.updateState(_this.state.year, index);

      _this.toggleMonthPicker();
    });

    _defineProperty(_assertThisInitialized(_this), "selectYear", function (year) {
      _this.updateState(year, _this.state.month);

      _this.toggleYearPicker();
    });

    _defineProperty(_assertThisInitialized(_this), "getYearsArray", function () {
      var arr = new Array(120);
      var year = getYear(new Date());

      for (var i = year - 100; i < year + 20; i++) {
        arr.push(i);
      }

      return arr;
    });

    _this.state = _this.getState(props);
    _this.yearPickerRef = /*#__PURE__*/React.createRef();
    _this.yearPickerSelectedRef = /*#__PURE__*/React.createRef();
    _this.monthPickerRef = /*#__PURE__*/React.createRef();
    _this.monthPickerSelectedRef = /*#__PURE__*/React.createRef();
    _this.timePickerRef = /*#__PURE__*/React.createRef();
    _this.timePickerFirstElementRef = /*#__PURE__*/React.createRef();
    _this.timePickerSelectedRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  var _proto = O2DatePickerEx.prototype;

  _proto.parseFormattedDate = function parseFormattedDate(strDate) {
    if (!strDate) {
      return;
    }

    if (typeof strDate === "string" || strDate instanceof String) {
      var formatArray = this.props.dateFormat.split(" ");
      var strArray = strDate.split(" ");

      if (strArray.length > 1) {
        return parse(strDate, this.props.dateFormat, new Date());
      } else {
        return parse(strArray[0], formatArray[0], new Date());
      }
    } else {
      return strDate;
    }
  };

  _proto.calculateCalendar = function calculateCalendar(year, month) {
    var date = new Date(year, month, 1);
    var firstCol = getDay(addDays(date, -1));
    var calendar = [];

    for (var row = 0;; row++) {
      calendar.push([]);

      for (var col = 0; col < 7; col++) {
        if (col >= firstCol && month === getMonth(date)) {
          calendar[row].push({
            day: getDate(date),
            current: true
          });
          date = addDays(date, 1);
        } else {
          calendar[row].push(null);
        }
      }

      firstCol = 0;

      if (month !== getMonth(date)) {
        break;
      }
    }

    var firstDate = new Date(year, month, calendar[1][0].day);
    var lastDate = new Date(year, month, calendar[calendar.length - 2][0].day);

    for (var _col = 0; _col < 7; _col++) {
      calendar[0][_col] = calendar[0][_col] === null ? {
        day: getDate(addDays(firstDate, -(7 - _col))),
        current: false
      } : calendar[0][_col];
      calendar[calendar.length - 1][_col] = calendar[calendar.length - 1][_col] === null ? {
        day: getDate(addDays(lastDate, 7 + _col)),
        current: false
      } : calendar[calendar.length - 1][_col];
    }

    return calendar;
  };

  _proto.getState = function getState(props) {
    var date = this.parseFormattedDate(props.selected);
    var selectedYear;
    var selectedMonth;
    var selectedDay;
    var selectedHour;
    var selectedMinute;

    if (!date || !isValid(date)) {
      date = new Date();
    } else {
      selectedYear = getYear(date);
      selectedMonth = getMonth(date);
      selectedDay = getDate(date);
      selectedHour = getHours(date);
      selectedMinute = getMinutes(date);
    }

    return {
      year: getYear(date),
      month: getMonth(date),
      selectedYear: selectedYear,
      selectedMonth: selectedMonth,
      selectedDay: selectedDay,
      selectedHour: selectedHour,
      selectedMinute: selectedMinute,
      calendar: this.calculateCalendar(getYear(date), getMonth(date)),
      monthPickerOpen: false,
      yearPickerOpen: false
    };
  };

  _proto.updateState = function updateState(year, month) {
    this.setState({
      year: year,
      month: month,
      calendar: this.calculateCalendar(year, month)
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevProps.selected !== this.props.selected) {
      this.setState(this.getState(this.props));
    }

    if (!prevProps.isOpen && this.props.isOpen) {
      this.setState({
        monthPickerOpen: false,
        yearPickerOpen: false
      });

      if (this.timePickerSelectedRef.current != null) {
        this.timePickerRef.current.scrollTop = this.timePickerSelectedRef.current.offsetTop - 50;
      }
    }
  };

  _proto.renderDate = function renderDate(row, col, selectedDay) {
    var _this2 = this;

    var date = this.state.calendar[row][col];

    if (date.current) {
      return /*#__PURE__*/React.createElement("td", {
        className: "xdsoft_date xdsoft_day_of_week" + (col + 1) + " " + (date.day === selectedDay ? "xdsoft_current" : ""),
        key: row * 7 + col,
        onClick: function onClick() {
          return _this2.pickDate(date);
        }
      }, /*#__PURE__*/React.createElement("div", null, date.day));
    } else {
      return /*#__PURE__*/React.createElement("td", {
        className: "xdsoft_date xdsoft_day_of_week" + (col + 1) + " xdsoft_other_month",
        key: row * 7 + col,
        onClick: function onClick() {
          return _this2.pickDate(date);
        }
      }, /*#__PURE__*/React.createElement("div", null, date.day));
    }
  };

  _proto.renderCalendarHead = function renderCalendarHead() {
    var _this3 = this;

    return /*#__PURE__*/React.createElement("div", {
      className: "xdsoft_monthpicker"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "xdsoft_prev",
      style: {
        visibility: "visible"
      },
      onClick: this.previousMonth
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "xdsoft_today_button",
      style: {
        visibility: "visible"
      },
      onClick: this.goToToday
    }), /*#__PURE__*/React.createElement("div", {
      className: "xdsoft_label xdsoft_month",
      onClick: this.toggleMonthPicker
    }, /*#__PURE__*/React.createElement("span", null, values.monthOfYear[this.state.month]), /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("div", {
      style: {
        position: "fixed",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
        display: "" + (this.state.monthPickerOpen ? "block" : "none")
      },
      onClick: this.toggleMonthPicker
    }), /*#__PURE__*/React.createElement("div", {
      className: "xdsoft_select xdsoft_monthselect xdsoft_scroller_box",
      style: {
        display: "block",
        visibility: "" + (this.state.monthPickerOpen ? "visible" : "hidden"),
        overflowY: "scroll"
      },
      ref: this.monthPickerRef
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: "0px"
      }
    }, values.monthOfYear.map(function (month, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: "xdsoft_option " + (_this3.state.month === index ? " xdsoft_current" : ""),
        key: month,
        onClick: function onClick() {
          return _this3.selectMonth(index);
        },
        ref: _this3.state.month === index ? _this3.monthPickerSelectedRef : null
      }, month);
    })))), /*#__PURE__*/React.createElement("div", {
      className: "xdsoft_label xdsoft_year",
      onClick: this.toggleYearPicker
    }, /*#__PURE__*/React.createElement("span", null, this.state.year), /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("div", {
      style: {
        position: "fixed",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
        display: "" + (this.state.yearPickerOpen ? "block" : "none")
      },
      onClick: this.toggleYearPicker
    }), /*#__PURE__*/React.createElement("div", {
      className: "xdsoft_select xdsoft_monthselect xdsoft_scroller_box",
      style: {
        display: "block",
        visibility: "" + (this.state.yearPickerOpen ? "visible" : "hidden"),
        overflowY: "scroll"
      },
      ref: this.yearPickerRef
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: "0px"
      }
    }, this.getYearsArray().map(function (year, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: "xdsoft_option " + (_this3.state.year === year ? " xdsoft_current" : ""),
        key: year,
        onClick: function onClick() {
          return _this3.selectYear(year);
        },
        ref: _this3.state.year === year ? _this3.yearPickerSelectedRef : null
      }, year);
    })))), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "xdsoft_next",
      style: {
        visibility: "visible"
      },
      onClick: this.nextMonth
    }));
  };

  _proto.renderDatePicker = function renderDatePicker() {
    var _this4 = this;

    var selectedDay = this.state.year === this.state.selectedYear && this.state.month === this.state.selectedMonth ? this.state.selectedDay : undefined;
    return /*#__PURE__*/React.createElement("div", {
      className: "xdsoft_datepicker active"
    }, this.renderCalendarHead(), /*#__PURE__*/React.createElement("div", {
      className: "xdsoft_calendar"
    }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, values.dayOfWeek[0]), /*#__PURE__*/React.createElement("th", null, values.dayOfWeek[1]), /*#__PURE__*/React.createElement("th", null, values.dayOfWeek[2]), /*#__PURE__*/React.createElement("th", null, values.dayOfWeek[3]), /*#__PURE__*/React.createElement("th", null, values.dayOfWeek[4]), /*#__PURE__*/React.createElement("th", null, values.dayOfWeek[5]), /*#__PURE__*/React.createElement("th", null, values.dayOfWeek[6]))), /*#__PURE__*/React.createElement("tbody", null, this.state.calendar.map(function (row, rowIndex) {
      return /*#__PURE__*/React.createElement("tr", {
        key: rowIndex
      }, row.map(function (col, colIndex) {
        return _this4.renderDate(rowIndex, colIndex, selectedDay);
      }));
    })))));
  };

  _proto.createTime = function createTime() {
    var times = [];
    var date = new Date();
    date = startOfDay(date);
    var today = date;

    while (isSameDay(date, today)) {
      times.push({
        hour: getHours(date),
        minute: getMinutes(date)
      });
      date = addMinutes(date, this.props.timeIntervals);
    }

    return times;
  };

  _proto.renderTimePicker = function renderTimePicker() {
    var _this5 = this;

    var times = this.createTime();
    return /*#__PURE__*/React.createElement("div", {
      className: "xdsoft_timepicker active"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "xdsoft_prev",
      onClick: this.timeUpHandler
    }), /*#__PURE__*/React.createElement("div", {
      className: "xdsoft_time_box xdsoft_scroller_box",
      style: {
        overflowY: "scroll"
      },
      ref: this.timePickerRef
    }, /*#__PURE__*/React.createElement("div", {
      className: "xdsoft_time_variant",
      style: {
        marginTop: "0px"
      }
    }, times.map(function (time, index) {
      return /*#__PURE__*/React.createElement("div", {
        key: time.hour + ":" + time.minute,
        className: "xdsoft_time " + (time.hour === _this5.state.selectedHour && time.minute === _this5.state.selectedMinute ? "xdsoft_current" : ""),
        onClick: function onClick() {
          return _this5.pickTime(time);
        },
        ref: index === 0 ? _this5.timePickerFirstElementRef : _this5.state.selectedHour === time.hour && _this5.state.selectedMinute === time.minute ? _this5.timePickerSelectedRef : null
      }, time.hour, ":", ("00" + time.minute).slice(-2));
    }))), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "xdsoft_next",
      onClick: this.timeDownHandler
    }));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        showTimeSelect = _this$props.showTimeSelect,
        showTimeSelectOnly = _this$props.showTimeSelectOnly;
    return /*#__PURE__*/React.createElement(O2TooltipPopoverWrapper, {
      isOpen: this.props.isOpen,
      target: this.props.target,
      placement: "bottom-start",
      trigger: "legacy",
      toggle: this.props.toggle
    }, /*#__PURE__*/React.createElement("div", {
      className: "o2-popover__arrow"
    }), /*#__PURE__*/React.createElement("div", {
      className: "o2-react_datepicker xdsoft_datetimepicker",
      style: {
        display: "block",
        whiteSpace: "nowrap"
      },
      ref: function ref(el) {
        if (el) {
          el.style.setProperty("position", "initial", "important");
        }
      }
    }, !showTimeSelectOnly && this.renderDatePicker(), (showTimeSelectOnly || showTimeSelect) && this.renderTimePicker()));
  };

  return O2DatePickerEx;
}(React.PureComponent);

export { O2DatePickerEx as default };
O2DatePickerEx.propTypes = {
  timeIntervals: PropTypes.number,
  showTimeSelect: PropTypes.bool,
  showTimeSelectOnly: PropTypes.bool,
  dateFormat: PropTypes.string
};
O2DatePickerEx.defaultProps = {
  timeIntervals: 30,
  showTimeSelect: false,
  showTimeSelectOnly: false,
  dateFormat: "dd.MM.yyyy"
};